var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "form-body" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.loading != 0,
            expression: "loading != 0"
          }
        ],
        staticClass: "row"
      },
      [
        _c(
          "div",
          { staticClass: "col-sm-12" },
          [
            _c("h2", [_vm._v(_vm._s(_vm.trans("form.please_wait")) + "...")]),
            _vm._v(" "),
            _c("ring-loader")
          ],
          1
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.loading == 0,
            expression: "loading == 0"
          }
        ]
      },
      [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-sm-12" },
            [
              _c("singleselect", {
                attrs: {
                  name: "package",
                  title: _vm.trans("bag_item.entity.package"),
                  options: _vm.packages,
                  checked: _vm.bagItem.package,
                  errors: _vm.form.options.errors,
                  label: "name"
                },
                model: {
                  value: _vm.bagItem.package,
                  callback: function($$v) {
                    _vm.$set(_vm.bagItem, "package", $$v)
                  },
                  expression: "bagItem.package"
                }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-sm-12" },
            [
              _c("singleselect", {
                attrs: {
                  name: "variant",
                  title: _vm.trans("bag_item.entity.variant"),
                  options: _vm.variants,
                  checked: _vm.bagItem.variant,
                  errors: _vm.form.options.errors,
                  label: "name"
                },
                model: {
                  value: _vm.bagItem.variant,
                  callback: function($$v) {
                    _vm.$set(_vm.bagItem, "variant", $$v)
                  },
                  expression: "bagItem.variant"
                }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-sm-12" },
            [
              _c("singleselect", {
                attrs: {
                  name: "mealType",
                  title: _vm.trans("bag_item.entity.meal_type"),
                  options: _vm.mealTypes,
                  checked: _vm.bagItem.mealType,
                  errors: _vm.form.options.errors,
                  "show-route-name": "meal_type_show",
                  label: "name"
                },
                on: { dispatch: _vm.getSizes },
                model: {
                  value: _vm.bagItem.mealType,
                  callback: function($$v) {
                    _vm.$set(_vm.bagItem, "mealType", $$v)
                  },
                  expression: "bagItem.mealType"
                }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-sm-12" },
            [
              _c("singleselect", {
                attrs: {
                  name: "size",
                  title: _vm.trans("bag_item.entity.size"),
                  options: _vm.sizes,
                  checked: _vm.bagItem.size,
                  errors: _vm.form.options.errors,
                  label: "name"
                },
                model: {
                  value: _vm.bagItem.size,
                  callback: function($$v) {
                    _vm.$set(_vm.bagItem, "size", $$v)
                  },
                  expression: "bagItem.size"
                }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-sm-12" },
            [
              _c("singleselect", {
                attrs: {
                  name: "status",
                  title: _vm.trans("bag_item.entity.status"),
                  options: _vm.statuses,
                  checked: _vm.bagItem.status,
                  errors: _vm.form.options.errors,
                  label: "value",
                  "show-route-name": "tag_show"
                },
                model: {
                  value: _vm.bagItem.status,
                  callback: function($$v) {
                    _vm.$set(_vm.bagItem, "status", $$v)
                  },
                  expression: "bagItem.status"
                }
              })
            ],
            1
          )
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2b0bf0fa", { render: render, staticRenderFns: staticRenderFns })
  }
}